<template>
  <CardToMobileLayout v-if="formFields.length" title="Parent/Guardian">
    <div class="row">
      <template v-for="field in formFields" :key="field.attrs.name">
        <component
          :is="field.comp"
          v-if="
            [
              'guardianPhone1',
              'guardianPhone2',
              'guardianPhone3',
              'guardianPhone4',
            ].includes(field.attrs.name)
          "
          v-bind="field.attrs"
          v-model:options="phoneOptions"
          :model-value="form[field.attrs.name]"
          :rules="field.rules"
          :form-name="formName"
          @update:model-value="form[field.attrs.name] = $event"
        />
        <component
          :is="field.comp"
          v-else
          v-bind="field.attrs"
          :options="unref(field.attrs.options)"
          :model-value="form[field.attrs.name]"
          :rules="field.rules"
          :form-name="formName"
          @update:model-value="form[field.attrs.name] = $event"
        />
      </template>
    </div>
  </CardToMobileLayout>
</template>

<script setup lang="ts">
import { computed, inject, unref } from "vue";

import { Application } from "../types";
import { GeneratedField } from "../useFieldGenerator";

interface Props {
  formName: string;
  formFields: GeneratedField[];
}

defineProps<Props>();
const form = inject("form") as Application;

const phoneOptions = computed(() => {
  const opts: Record<string, boolean> = {
    Cell: true,
    Home: true,
    Work: true,
    Other: true,
  };

  const taken = [
    form.guardianPhone1?.type,
    form.guardianPhone2?.type,
    form.guardianPhone3?.type,
    form.guardianPhone4?.type,
  ].filter((v) => v != null);

  taken.forEach((v) => (opts[v] = false));

  return opts;
});
</script>

<style scoped>
.row > :nth-child(n + 1) {
  margin-top: 1rem;
}
</style>
